import React from "react";

const FullScreenLoader: React.FC<{ message?: string }> = ({
  message = "Loading…",
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-base-100">
    <div className="flex flex-col items-center gap-4">
      <h1 className="text-base-content text-[12rem] font-light font-groteskLogo leading-none animate-pulse-custom">
        ^
      </h1>
      <p className="text-md -mt-16 font-medium text-base-content/70 font-grotesk text-center">
        {message}
      </p>
    </div>
  </div>
);

export default FullScreenLoader;
